import list from './list';
import marks, { InteractiveObjectLink } from './marks';
import types, { Footnote, PreventUpscalePTImage } from './types';
import blocks from './blocks';
import { type PortableTextComponents } from '@portabletext/react';

// Base PortableText components
const ptComponents: PortableTextComponents = {
	marks: marks,
	list: list,
	types: types,
	block: blocks,
};

export default ptComponents;

// These are one-off components that are used in specialized rich text
// editor contexts only.
export { Footnote, PreventUpscalePTImage };
export { InteractiveObjectLink };
